/**
 *
 * FBAdminAnswerCard
 *
 */

import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

// styles
import './style.scss';

import { AddToCalendarButton } from 'add-to-calendar-button-react';

// icons
import CustomIcons from 'components/CustomIcons';

// custom react-multi-date-picker
import { DateObject } from 'react-multi-date-picker';
import { timeFormat } from 'utils/moment/moment.constant';
import { convertDateToString, convertSecondsToTime } from "utils/moment/moment.utils";
import _local from 'utils/localStorageUtils';


function FBAdminAnswerCard({
  currentElement,
  adminAnswer,
  answeredRecipient,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-admin-answer', className);
  const { t, i18n } = useTranslation();
  const localUser = _local.getLocalUser();

  const formatDateTimeValue = useCallback((value, format) => {
    if (!!!value) {
      return '';
    }

    if (typeof value == 'object') {
      const isoDateString = value.toDate().toISOString();
      return !!value && convertSecondsToTime(isoDateString, format);
    } else {
      // Set CET time zone offset manually (in minutes, CET is UTC+1)
      const data = new DateObject(value);
      const isoDateString = data.toDate().toISOString();
      return !!value && convertSecondsToTime(isoDateString, format);
    }

  }, []);

  const calendarData = {
    name: currentElement?.title, 
    description: t("components.FBAdminAnswerCard.description", {
      date: adminAnswer?.slot?.dateFormat,
      timeFrom: formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat),
      timeTo: formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat)
    }),
    startDate: convertDateToString(adminAnswer?.slot?.date, "YYYY-MM-DD"),
    endDate: convertDateToString(adminAnswer?.slot?.date, "YYYY-MM-DD"),
    startTime: formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat),
    endTime: formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat),
    options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com'],
    timeZone: "Atlantic/Jan_Mayen",
    iCalFileName: "Reminder-Event",
    label: t("components.FBAdminAnswerCard.buttonLabel"),
    language: i18n?.language || "fr",
    checkmark: false,
    icons: false
  };

  return !!adminAnswer && (
    <div {...rest} className={childClassNames}>

      <div className="slot-wrapper">
        <div className="slot slot-date">
          <CustomIcons className="slot-icon" type="calendar" />
          {adminAnswer?.slot?.dateFormat}
        </div>
        <div className="slot slot-time">
          <CustomIcons className="slot-icon" type="time" />
          {`${formatDateTimeValue(adminAnswer?.slot?.timeFrom, timeFormat)} - ${formatDateTimeValue(adminAnswer?.slot?.timeTo, timeFormat)}`}
        </div>
      </div>

      <div className="slot-description">
        {t("components.FBAdminAnswerCard.slotDescription")}
      </div>

      {(!!answeredRecipient &&
        answeredRecipient?.description?.firstname && answeredRecipient?.description?.lastname &&
        localUser?._id == answeredRecipient?._id
      ) && (
          <div className="answered-parent">
            <span>{t("components.FBAdminAnswerCard.answeredBy")}</span>
            <span className="name">{`${answeredRecipient?.description?.lastname} ${answeredRecipient?.description?.firstname}`}</span>
          </div>
        )}

      <AddToCalendarButton
        {...calendarData}
      //  buttonsList
       // hideTextLabelButton
     //   buttonStyle="round"
        lightMode="bodyScheme"
      >
        {t("components.FBAdminAnswerCard.buttonLabel")}
      </AddToCalendarButton>

    </div>
  );
}

FBAdminAnswerCard.defaultProps = {
  adminAnswer: null,
  answeredRecipient: null,
};

export default memo(FBAdminAnswerCard);
